/*
  Smart Cart free-item urgency prototype

  Rebuy owns mount placement through a Custom Code Block. This module only
  renders availability data and never changes cart, gift, discount or progress
  bar state.
*/
(function () {
  const CONFIG_ID = 'bwb-smart-cart-urgency-config';
  const MOUNT_SELECTOR = '[data-bwb-smart-cart-urgency]';
  const RENDER_DELAY = 100;

  function debugLog(...args) {
    if (window.bwbSmartCartUrgencyDebug === true) {
      console.log('[SmartCartUrgency]', ...args);
    }
  }

  function readConfig() {
    const configElement = document.getElementById(CONFIG_ID);
    if (!configElement) return null;

    try {
      const config = JSON.parse(configElement.textContent || '{}');
      return config && config.enabled === true ? config : null;
    } catch (error) {
      debugLog('Unable to parse configuration', error);
      return null;
    }
  }

  function toNonNegativeInteger(value) {
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? Math.floor(number) : null;
  }

  function getPercentage(config) {
    if (config.usePercentageOverride === true) {
      const override = toNonNegativeInteger(config.percentageOverride);
      return override === null ? null : Math.min(100, override);
    }

    if (!config.liquidSnapshot?.variantId) return null;

    const remaining = toNonNegativeInteger(config.liquidSnapshot.remaining);
    const campaignAllowance = toNonNegativeInteger(config.campaignAllowance);
    if (remaining === null || !campaignAllowance) return null;

    return Math.min(100, Math.max(0, Math.round((remaining / campaignAllowance) * 100)));
  }

  function createElement(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function buildContent(percentage) {
    const content = createElement('div', 'bwb-smart-cart-urgency__content');
    content.dataset.bwbSmartCartUrgencyRendered = 'true';
    content.setAttribute('role', 'status');
    content.setAttribute('aria-live', 'polite');
    content.setAttribute('aria-atomic', 'true');

    if (percentage <= 20) {
      content.classList.add('bwb-smart-cart-urgency__content--critical');
    }

    content.append(
      createElement('p', 'bwb-smart-cart-urgency__label', '🎁 Gratisgeschenk'),
      createElement('p', 'bwb-smart-cart-urgency__message', `${percentage} % VERFÜGBAR`)
    );

    return content;
  }

  function giftTierReached() {
    const steps = document.querySelectorAll(
      '[data-rebuy-cart-anchor="goalBox"] [data-rebuy-component="progress-bar"] .rebuy-cart__progress-step'
    );

    return steps.length > 1 && Array.from(steps).every((step) => step.classList.contains('complete'));
  }

  function createController(config) {
    let renderTimer = null;
    let destroyed = false;

    function render() {
      renderTimer = null;
      if (destroyed) return;

      const percentage = getPercentage(config);
      if (percentage === null) {
        debugLog('No valid percentage value; skipping render');
        return;
      }

      const mount = document.querySelector(MOUNT_SELECTOR);
      if (!mount) {
        debugLog('Urgency mount is not available yet');
        return;
      }

      if (giftTierReached()) {
        mount.replaceChildren();
        delete mount.dataset.bwbSmartCartUrgencyMounted;
        return;
      }

      mount.replaceChildren(buildContent(percentage));
      mount.dataset.bwbSmartCartUrgencyMounted = 'true';
    }

    function scheduleRender(delay = 0) {
      if (destroyed) return;
      if (renderTimer) window.clearTimeout(renderTimer);
      renderTimer = window.setTimeout(render, delay);
    }

    function onSmartCartReady() {
      scheduleRender(RENDER_DELAY);
    }

    function onSmartCartShow() {
      scheduleRender(RENDER_DELAY);
    }

    function onDomReady() {
      scheduleRender();
    }

    document.addEventListener('rebuy:smartcart.ready', onSmartCartReady);
    document.addEventListener('rebuy:smartcart.show', onSmartCartShow);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
    } else {
      onDomReady();
    }

    return {
      destroy() {
        destroyed = true;
        if (renderTimer) window.clearTimeout(renderTimer);
        document.removeEventListener('rebuy:smartcart.ready', onSmartCartReady);
        document.removeEventListener('rebuy:smartcart.show', onSmartCartShow);
        document.removeEventListener('DOMContentLoaded', onDomReady);
      },
      render: () => scheduleRender(),
    };
  }

  window.SmartCartUrgency?.destroy?.();

  const config = readConfig();
  if (!config) return;

  window.SmartCartUrgency = createController(config);
})();
